
import urlUtil from '../../util-url.js'
import modal from '../../modal.vue'
import { UarmUcmPageToWord } from '@uarmSrc/types'

/**
 * Компонент ВЫГРУЗКИ в word
 * https://wiki.oooinex.ru/pages/viewpage.action?pageId=53285746
 */
export default {
	name: 'ExportWord',
	props: {
		/** Объекта ucmPageToWord из метаданных */
		options: {
			required: true,
			type: Object // as UarmUcmPageToWord,
		},
		show_context: {
			required: true,
			type: String,
		},
		arm_id: {
			required: true,
			type: Number,
		},
		add_query: {
			required: false,
			type: String,
			default: '',
		},
	},
	components: {
		modal: modal,
	},
	computed: {
		isNeedFillFilter() {
			return Boolean(this.options.isNeedFillFilter)
		},
		filterQuery() {
			// в add_query сначала идет ? который нам не нужен. Проверка на всякий, чтобы точно не сломать
			return (this.add_query.indexOf('?') === 0) ? this.add_query.replace('?', '') : this.add_query;
		},
	},
	data: function () {
		/* var base_href = urlUtil.getServiceUrl({
			methodName: 'word/word-from-html',
			armId: this.$props.arm_id,
			vpId: this.$route.params.vpId,
			context: this.$props.show_context,
		}) */
		// Сервис выгрузки описан здесь https://wiki.oooinex.ru/pages/viewpage.action?pageId=113018269
		const base_href = `${urlUtil.getDomain()}/html-exporter/export/${this.$route.params.vpId}/word${this.$props.options.isXML ? '/xml' : '/'}`;
		return {
			base_href,
			show_popup: false,
			hasPopup: !!(this.$props.options.paramFields && this.$props.options.paramFields.length),
			ownMeta: Object.assign({}, this.$props.options) as UarmUcmPageToWord,
			linkTarget: '_self',
		}
	},
	mounted: function () {
		if (!this.$props.options.ucmPageId) {
			alert('В параметрах выгрузки не указан ID пейджа');
		}
	},
	methods: {
		startDownload: function () {
			this.$emit('started');
			this.logReportUrl()
		},
		togglePopup: function (bShow: boolean = false) {
			this.$data.show_popup = !!bShow;
		},
		onMainButtonClick: function (evt) {
			// PIRS2018-3156
			if (this.isNeedFillFilter && !this.filterQuery) {
				evt.preventDefault(); // PIRS2018-7598
				alert('Для выгрузки файла, пожалуйста, заполните хотя бы одно поле поисковой формы.')
				return false;
			}

			if (this.$data.hasPopup) {
				evt.preventDefault();
				this.togglePopup(true);
				this.logReportUrl();
			}
			else {
				this.startDownload();
			}
		},
		logReportUrl: function () {
			console.log('ExportWord. URL выгрузки (см. примечание про домен):', this.getHref(true));
			console.log(`ExportWord. Домен этого урла выше взят из ${urlUtil.isWizard ? 'константы' : 'адресной строки'}, но по факту сервер вычисляет его из path запроса, там его айди стоит сразу перед айди АРМ`);
		},
		getHref: function (bDebugLink: boolean = false) {

			// /{siteId}/{armId}/word/word-from-html + 2 параметра
			// fileName - имя файла , опционально
			// reportUrl - урл html c отчетом (не забыть заскейпить)


			var showFieldsParams = ''; // какие поля показывать, какие-нет (содержимое попапа)
			if (this.$data.ownMeta.paramFields) {
				this.$data.ownMeta.paramFields.forEach(function (f) {
					if (f.isChecked) {
						showFieldsParams += '&' + f.name + '=1';
					}
				})
			}
			var reportUrlUnencodedPart = '/ru/page/' + this.$props.options.ucmPageId + '/?' + showFieldsParams + '&';

			// PIRS-2-14791
			// Сначала декодируем строку, триммим пробелы на конце параметров, потом обратно кодируем
			let filterQuery = encodeURIComponent(decodeURIComponent(this.filterQuery).split('&').map(i => i.trim()).join('&'));

			// PIRS2018-2607
			// суть в том что есть символ +, uarm получает с клиента reportUrl в urlencoded виде и раскодирует,
			// + становится плюсом и интерпретируется как пробел, в итоге формат даты неверный
			// поэтому подвергаем его двойному кодированию с помощью автозамены
			// (сплит/джойн это быстрая глобальная автозамена без регулярки)
			var encodedPlus = encodeURIComponent('+');
			filterQuery = filterQuery.split(encodedPlus).join(encodeURIComponent(encodedPlus));

			// add_query уже заэнкожен. Точнее заэнкожены только значения, а имена параметров и амперсанды - нет.
			// Несмотря на это, сейчас работает корректно, трогать не стал.
			var reportUrl = window.encodeURIComponent(reportUrlUnencodedPart) + filterQuery;

			if (bDebugLink) {
				// если передать bHtmlPage=true то ф-ция вернет незаэскейпленный урл пейджа,
				// по которому можно перейти и отлаживаться
				// пример урла выгрузки https://new-company.local.oooinex.ru/ru/page/5855/?&show-code=1&show-name=1&show-email=1&show-theme_id=1&show-region_id=1&show-date_quest=1&show-question=1&show-mdata=1&last_name=%D0%90%D0%BD%D0%B4%D1%80%D0%B5%D0%B5%D0%B2&
				// реальный урл лежит в логе арма ("Try get word export html from")
				var htmlPageDomain;
				if (urlUtil.isWizard) {
					htmlPageDomain = 'https://new-company.local.oooinex.ru';
				}
				else {
					htmlPageDomain = window.location.protocol + '//' + window.location.host;
				}
				return htmlPageDomain + window.decodeURIComponent(reportUrl);
			}
			else {
				var fileNameParam = '';
				if (this.$props.options.fileName) {
					var datetimeStr = (new Date()).toLocaleString('ru').replace(/[\.:]/g, '-').replace(' ', '_').replace(',', '').replace(/[\u200E]/g, '');
					console.log('ExportWord. дата/время:', datetimeStr, ', количество символов:', datetimeStr.length);
					var fileNameValue = this.$props.options.fileName.replace('#datetime#', datetimeStr);
					fileNameParam = '&fileName=' + fileNameValue;
				}

				return this.$data.base_href + '?reportUrl=' + reportUrl + fileNameParam;
			}
		}
	}
}
